import API from '../api';

// ── 알림 소리 재생 공용 유틸 ────────────────────────────────────────────
// 서버(backend/sound/*.mp3)에 미리 올려둔 알림음 파일을 재생한다. server.js에
// app.use('/sound', express.static(path.join(__dirname, 'sound')))로 정적 제공되고 있어서,
// API.baseURL("http://호스트:포트/api")에서 마지막 "/api"를 떼어낸 주소가 곧 파일 루트가 된다.
//   - message : 사내메신저 새 메시지 도착      → backend/sound/messege_sound.mp3
//   - update  : 각 메뉴 등록/수정/삭제(최신글표시) → backend/sound/new_update_alarm.mp3
//   - task    : 업무요청 도착/대응              → backend/sound/task_alarm.mp3
const SERVER_ROOT = (API.defaults.baseURL || '').replace(/\/api\/?$/, '');

const FILES = {
  message: 'messege_sound.mp3',
  update: 'new_update_alarm.mp3',
  task: 'task_alarm.mp3',
};

// 매번 새 Audio 객체를 만들지 않고 종류별로 하나씩만 재사용한다(같은 종류의 알림이 연달아
// 와도 currentTime을 0으로 되돌려 처음부터 다시 재생).
const cache = {};

function getAudio(key) {
  const file = FILES[key];
  if (!file) return null;
  if (!cache[key]) {
    cache[key] = new Audio(`${SERVER_ROOT}/sound/${file}`);
  }
  return cache[key];
}

// 브라우저 자동재생 정책 등으로 재생이 막히는 경우(예: 사용자가 아직 페이지를 한 번도
// 클릭하지 않은 상태)가 있을 수 있어, 실패해도 조용히 무시하고 화면 동작에는 영향을 주지 않는다.
export function playSound(key) {
  const audio = getAudio(key);
  if (!audio) return;
  try {
    audio.currentTime = 0;
    const p = audio.play();
    if (p && typeof p.catch === 'function') p.catch(() => {});
  } catch (e) { /* ignore */ }
}